import type { ToolDetailField } from "@/lib/tool-details";

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const TASK_ID = /\bTask ID: ([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?![0-9a-f-])/i;

export function workflowTaskIdFromToolResult(
  name: string,
  status: "start" | "end" | "error",
  result: ToolDetailField | null | undefined,
  persistedTaskId?: unknown,
): string | null {
  if ((name !== "run_workflow" && name !== "run_workflow_direct") || status !== "end") return null;
  if (typeof persistedTaskId === "string" && UUID.test(persistedTaskId)) {
    return persistedTaskId;
  }
  if (result?.state !== "available" || typeof result.value !== "string"
    || !result.value.startsWith("Workflow started from ")) return null;
  return TASK_ID.exec(result.value)?.[1] ?? null;
}
